module.exports = __webpack_public_path__ + "static/img/bg00.ce2e48a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg00.jpg
// module id = 1vMq
// module chunks = 1